export const defaultStyles = {
    "defaultVertex": {
        "shape": "label",
        "perimeter": "rectanglePerimeter",
        "fontSize": "14",
        "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, Helvetica, sans-serif",
        "align": "center",
        "verticalAlign": "middle",
        "fillColor": "#dbeafe",
        "gradientColor": "#ffffff",
        "gradientDirection": "east",
        "strokeColor": "#60a5fa",
        "strokeWidth": "1",
        "fontColor": "#000000",
        "shadow": "1",
        "rounded": "1",
        "arcSize": "10",
        "absoluteArcSize": "1",
        "rotatable": "0",
        "bendable": "0"
    },
    "defaultEdge": {
        "shape": "connector",
        "labelBackgroundColor": "#ffffff",
        "endArrow": "classic",
        "fontSize": "14",
        "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, Helvetica, sans-serif",
        "align": "center",
        "verticalAlign": "middle",
        "shadow": "1",
        "rounded": "1",
        "strokeColor": "#666666",
        "fontColor": "#000000",
        "rotatable": "0"
    },
    "text": {
        "fillColor": "none",
        "gradientColor": "none",
        "strokeColor": "none",
        "align": "left",
        "verticalAlign": "top"
    },
    "label": {
        "fontStyle": "1",
        "align": "left",
        "verticalAlign": "middle",
        "imageWidth": "42",
        "imageHeight": "42",
        "rounded": "1"
    },
    "ellipse": {
        "shape": "ellipse",
        "perimeter": "ellipsePerimeter",
        "align": "center",
        "verticalAlign": "middle",
        "gradientColor": "#ffffff",
        "gradientDirection": "east",
        "fontColor": "#000000",
        "shadow": "1"
    },
    "start": {
        "shape": "ellipse",
        "fillColor": "#A0C88F",
        "strokeColor": "#A0C88F",
        "verticalLabelPosition": "top",
        "deletable": "0",
        "resizable": "0",
        "rotatable": "0",
        "cloneable": "0",
        "selectable": "0"
    },
    "task": {
        "image": "/images/account-outline.svg",
        "align": "left",
        "imageAlign": "left",
        "verticalAlign": "middle",
        "imageVerticalAlign": "middle",
        "spacingLeft": "35",
        "spacing": "5",
        "imageWidth": "25",
        "imageHeight": "25",
    },
    "http": {
        "image": "/images/cog-transfer-outline.svg",
        "fillColor": "#fef3c7",
        "gradientColor": "#ffffff",
        "strokeColor": "#fbbf24",
        "align": "left",
        "imageAlign": "left",
        "verticalAlign": "middle",
        "imageVerticalAlign": "middle",
        "spacingLeft": "35",
        "spacing": "5",
        "imageWidth": "25",
        "imageHeight": "25",
    },
    "jq": {
        "image": "/images/logo-jq.png",
        "fillColor": "#f3e8ff",
        "gradientColor": "#ffffff",
        "strokeColor": "#c084fc",
        "align": "left",
        "imageAlign": "left",
        "verticalAlign": "middle",
        "imageVerticalAlign": "middle",
        "spacingLeft": "35",
        "spacing": "5",
        "imageWidth": "25",
        "imageHeight": "13.75",
    },
    "wait": {
        "image": "/images/timer-outline.svg",
        "fillColor": "#f3f4f6",
        "gradientColor": "#ffffff",
        "strokeColor": "#9ca3af",
        "align": "left",
        "imageAlign": "left",
        "verticalAlign": "middle",
        "imageVerticalAlign": "middle",
        "spacingLeft": "35",
        "spacing": "5",
        "imageWidth": "25",
    },
    "email": {
      "image": "/images/email-outline.svg",
      "fillColor": "#ccfbf1",
      "gradientColor": "#ffffff",
      "strokeColor": "#2dd4bf",
      "align": "left",
      "imageAlign": "left",
      "verticalAlign": "middle",
      "imageVerticalAlign": "middle",
      "spacingLeft": "35",
      "spacing": "5",
      "imageWidth": "25",
    },
    "end": {
      "shape": "ellipse",
      "fillColor": "#DACCBC",
      "gradientColor": "#ffffff",
      "strokeColor": "#AF7F73",
      "verticalLabelPosition": "top",
      "resizable": "0",
      "rotatable": "0"
    },
    "map": {
      "image": "/images/state-machine.svg",
      "fillColor": "#c7d2fe",
      "gradientColor": "#ffffff",
      "strokeColor": "#818cf8",
      "align": "left",
      "imageAlign": "left",
      "verticalAlign": "middle",
      "imageVerticalAlign": "middle",
      "spacingLeft": "35",
      "spacing": "5",
      "imageWidth": "25"
    },
    "rhombus": {
        "shape": "rhombus",
        "perimeter": "rhombusPerimeter"
    },
    "triangle": {
        "shape": "triangle",
        "perimeter": "trianglePerimeter"
    },
    "line": {
        "shape": "line",
        "strokeWidth": "4",
        "labelBackgroundColor": "#ffffff",
        "verticalAlign": "top",
        "spacingTop": "8"
    },
    "image": {
        "shape": "image",
        "labelBackgroundColor": "white",
        "verticalAlign": "top",
        "verticalLabelPosition": "bottom",
    },
    "rhombusImage": {
        "shape": "image",
        "labelBackgroundColor": "white",
        "verticalAlign": "top",
        "verticalLabelPosition": "bottom",
        "perimeter": "rhombusPerimeter"
    },
    "arrow": {
        "shape": "arrow",
        "edgeStyle": "none",
        "fillColor": "#ffffff"
    }
};
